import { useCallback } from 'react';
import { useAppState } from '../contexts/appState';
import { handleAlertSnackbar } from '../reducersAndActions/actions/appStateActions';

export default function useAlert() {
  const [, dispatch] = useAppState();
  const setAlert = useCallback(
    (alert) => {
      handleAlertSnackbar(dispatch, {
        message: alert.message || '',
        status: alert.status || '',
      });
    },
    [dispatch],
  );

  return [setAlert];
}
